<template>
  <div class="cash-withdrawal-record">
    <div class="record-card">
      <div class="my-card-title">信用金明细</div>
      <div class="table-wrap">
        <el-table :data="list" v-loading="loading" element-loading-text="给我一点时间" :empty-text="emptyText" border fit
          highlight-current-row>
          <el-table-column label="序号" align="center" width="150" prop="id">
          </el-table-column>
          <el-table-column label="变更前" align="center" width="150" prop="before">
          </el-table-column>
          <el-table-column label="变更金额" align="center" width="150" prop="change">
          </el-table-column>
          <el-table-column label="变更后" align="center" width="150" prop="after">
          </el-table-column>
          <el-table-column label="备注" align="center" width="150" prop="remark">
          </el-table-column>
          <el-table-column label="变更时间" align="center" minWidth="150" prop="create_time">
          </el-table-column>
        </el-table>
        <div class="flex-row mgt20">
          <div class="flex-grow-1"></div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCreditDepositList as getTeamCreditDepositList } from "@/api/team";
import { getCreditDepositList as getUserCreditDepositList } from "@/api/user";
export default {
  name: 'TeamCreditDeposit',
  components: {

  },
  data() {
    return {
      loading: true,
      emptyText: '暂无数据',
      listQuery: {
        status: '0',
        page: 1,
        pagesize: 10
      },
      list: [],
      total: 0,
      type: ''
    };
  },
  computed: {

  },
  created() {
    this.type = this.$route.params.type;
    if (this.type == 'team') {
      this.getTeamCreditDepositList();
    } else {
      this.getUserCreditDepositList();
    }
  },
  methods: {
    // 获取列表
    getTeamCreditDepositList() {
      this.loading = true;
      const _listQuery = Object.assign({}, this.listQuery);
      getTeamCreditDepositList(_listQuery)
        .then((response) => {
          this.list = response.data.list;
          this.total = response.data.count * 1;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 获取列表
    getUserCreditDepositList() {
      this.loading = true;
      const _listQuery = Object.assign({}, this.listQuery);
      getUserCreditDepositList(_listQuery)
        .then((response) => {
          this.list = response.data.list;
          this.total = response.data.count * 1;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 查询
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 更改每页行数
    handleSizeChange(val) {
      this.listQuery.pagesize = val;
      this.getList();
    },
    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  }
};
</script>

<style lang="scss" scoped>
.cash-withdrawal-record {
  width: 100%;
  padding: 20px 0 227px 0;
  box-sizing: border-box;
  background-color: #F4F8F9;
  display: flex;
  align-items: center;
  flex-direction: column;

  .record-card {
    width: 1001px;
    background: #FFFFFF;
    box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.0196);

    .table-wrap {
      width: 100%;
      padding: 20px 32px;
      box-sizing: border-box;

      .table {
        border: 1px solid #DCE5EB;
      }

      th {
        text-align: center;
        padding: 13px 0;
      }

      thead {
        tr {
          th {
            background-color: #DCE5EB;
          }

          th:nth-child(1) {
            width: 34%;
          }

          th:nth-child(2) {
            width: 12%;
          }

          th:nth-child(3) {
            width: 10%;
          }

          th:nth-child(4),
          th:nth-child(5) {
            width: 22%;
          }
        }
      }

      tbody {
        &>.empty {
          position: relative;
          height: 43px;

          &>th {
            position: absolute;
            width: 100%;
            height: 43px;
            font-size: 15px;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
